import React from "react";
import { Link } from "react-router-dom";

export default function ResearchAnalyst() {
  return (
    <>
      <style>{`
@media (max-width: 991px) {
section.section-padding.text-white.text-center {
    text-align: initial !important;
    padding-bottom: 30px;
}
    
}
              `}</style>

      <section
        className="section-padding"
        style={{
          background:
            "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
          paddingTop: "8 0px",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left Content */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="mb-4">
                Empowering Smarter Investments Through Trusted Research
              </h2>
              {/* <h4 className="fw-semibold text-dark mb-4">
                Smart Insights. Informed Decisions.
              </h4> */}
              <p
                className=" mb-2"
                style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#000" }}
              >
                At <strong>GPS Finvest</strong>, we believe every great
                investment begins with reliable research. Our Research &
                Analysis (RA) platform provides authentic, data-driven insights
                into financial markets — helping investors, analysts, and
                learners make smarter, evidence-based decisions.
              </p>
            </div>

            {/* Right Features Grid */}
            <div
              className="col-lg-6"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src="/images/ChatGPT_Image_Nov_6__2025__05_24_29_PM-removebg-preview.png" style={{ height: "auto" }} />
            </div>
          </div>
        </div>
      </section>



      {/* 🌐 Our Research Spectrum */}
      <section className="py-5  text-center">
        <div className="container">
          <h2 className="mb-4">Our Research Spectrum</h2>
          <p
            className="mb-5"
            style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#000" }}
          >
            Explore multiple dimensions of the economy and markets through our
            structured research framework.
          </p>

          <div className="row g-4">
            {[
              {
                title: "Industrial View",
                text: "Get real-time insights into key industry sectors — manufacturing, IT, pharma, energy, and more.",
              },
              {
                title: "Domestic Economy",
                text: "Track India’s GDP, inflation, and fiscal policies using data from RBI, NSE, and BSE.",
              },
              {
                title: "Global Economy",
                text: "Understand how international markets, currencies, and commodities affect Indian investments.",
              },
            ].map((item, index) => (
              <div key={index} className="col-md-4">
                <div className="card h-100 shadow border-0">
                  <div className="card-body">
                    <h5 className="fw-bold mb-3" style={{ color: "#1E2E50 " }}>
                      {item.title}
                    </h5>
                    <p
                      style={{
                        fontSize: "1.1rem",
                        lineHeight: "1.8",
                        color: "#000",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 📈 Stock Research Section */}
      <section
        className="py-5  text-center"
        id="reports"
        style={{
          background:
            "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
          paddingTop: "80px",
        }}
      >
        <div className="container">
          <h2 className="mb-4"> Stock Research</h2>
          <p
            className="lead mb-5"
            style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#000" }}
          >
            Make informed stock decisions with detailed fundamental and
            technical analysis reports.
          </p>

          <div className="row g-4">
            {[
              "Real-time stock data & technical charts",
              "Fundamental research reports",
              "Price targets & growth potential",
              "Top gainers/losers analysis",
            ].map((text, i) => (
              <div key={i} className="col-md-6 col-lg-3">
                <div className="p-4 bg-light rounded shadow-sm h-100">
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.8",
                      color: "#000",
                    }}
                  >
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* 3,967 */}

          <div className="mt-4">
            <Link
              to="/clientresearchanalysis"
              className="btn btn-primary"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              View Stock Research Reports
            </Link>
          </div>
        </div>
      </section>

      {/* 💼 Portfolio Back-Testing */}
      <section className="py-5  text-center">
        <div className="container">
          <h2 className=" mb-4">Portfolio Back-Testing & Analytics</h2>
          <p
            className=" mb-5"
            style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#000" }}
          >
            Simulate your investment strategies with our back-testing tool to
            analyze risk, performance, and returns.
          </p>

          <div className="row g-4">
            {[
              "Analyze past performance",
              "Adjust allocations and risk levels",
              "Compare strategies with benchmarks",
              "Get visual reports on returns & volatility",
            ].map((text, i) => (
              <div key={i} className="col-md-6 col-lg-3">
                <div className="bg-white rounded shadow-sm p-4 h-100">
                  <p className="fw-medium text-dark mb-0">{text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="mt-4">
            <Link to="/login" className="btn btn-primary ">
            Try Portfolio Back-Tester
            </Link>
     
          </div> */}
        </div>
      </section>

      {/* 🔒 Security Section */}
      <section
        className="py-5 text-center"
        style={{
          background:
            "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
          paddingTop: "80px",
        }}
      >
        <div className="container">
          <h2 className=" mb-4">Authenticity & Data Protection</h2>
          <p
            className="mb-5"
            style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#000" }}
          >
            Every data point comes from verified sources — ensuring trust and
            transparency.
          </p>

          <div className="row g-4">
            {[
              "All RA data is read-only (no copy/paste/download)",
              "Access restricted to registered/premium users",
              "Advanced encryption & server-side validation",
              "Secure audit trails for every report",
            ].map((text, i) => (
              <div key={i} className="col-md-6 col-lg-3">
                <div className="p-4 bg-light rounded shadow-sm h-100">
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.8",
                      color: "#000",
                    }}
                  >
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ⚙️ User Access Table */}
      <section className="py-5 ">
        <div className="container">
          <h2 className=" mb-4  text-center"> User Access Levels</h2>
          <div className="table-responsive">
            <table className="w-full border-collapse border border-gray-200 rounded-lg overflow-hidden shadow-lg">
              <thead className="text-white" style={{ background: "#1bafb4" }}>
                <tr>
                  <th className="px-6 py-4 text-left">Access Type</th>
                  <th className="px-6 py-4 text-left">Description</th>
                  <th className="px-6 py-4 text-left">Available Features</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-6 py-4 font-medium">Basic (Free)</td>
                  <td className="px-6 py-4">
                    Educational access for beginners
                  </td>
                  <td className="px-6 py-4">
                    Learn fundamentals, view sample reports
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-medium">Registered</td>
                  <td className="px-6 py-4">
                    Verified users with PAN-based login
                  </td>
                  <td className="px-6 py-4">
                    Full research access, dashboard tools
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-medium">Premium</td>
                  <td className="px-6 py-4">Subscription-based users</td>
                  <td className="px-6 py-4">
                    Advanced analytics, secure reports, priority support
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 🌟 Why Choose Section */}
      <section
        className="py-5  text-center"
        style={{
          background:
            "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
          paddingTop: "80px",
        }}
      >
        <div className="container">
          <h2 className=" mb-4">Why Choose GPS Finvest Research</h2>
          <div className="row g-4">
            {[
              "Data-backed insights from verified sources (ET, NSE, RBI)",
              "Tools for stock research, portfolio testing & strategy simulation",
              "High-security environment with no data leaks",
              "Suitable for both professionals and learners",
              "Integrated with advisory, insurance, and loan modules",
            ].map((text, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div className="bg-light rounded shadow-sm p-4 h-100">
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.8",
                      color: "#000",
                    }}
                  >
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="mt-5 d-flex flex-wrap justify-content-center gap-3">
            <Link to="/login" className="btn btn-primary ">
            Start Researching
            </Link>
            <Link to="/login" className="btn btn-primary ">
            Login to Dashboard
            </Link>
            <Link to="/login" className="btn btn-primary ">
            Login to Dashboard
            </Link>
            <Link to="/login" className="btn btn-primary ">
            Upgrade to Premium
            </Link>
          </div> */}
        </div>
      </section>
    </>
  );
}
